import { useInIframe } from "@/v2/hooks/useInIframe";

export const useEventCommunicator = () => {
  const isInIframe = useInIframe();
  const REACT_APP_PARENT_ORIGIN = process.env.REACT_APP_PARENT_ORIGIN;

  const eventEmitter = (message: IEventData) => {
    if (!isInIframe) return;
    window.parent.postMessage(JSON.stringify(message), REACT_APP_PARENT_ORIGIN || "*");
  };
  return { eventEmitter };
};

interface IEventData {
  type: EventType;
  data?: Record<string, any>;
}

type EventType = "TASK_MANAGER_UPDATE" | "AUTH_STATE_CHANGED";
